import { trackingPageBlockDeleteButtonClassName } from '@reveni-io/reveni-ui'

import { previewViewModes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'

export const fadeInitial = { opacity: 0 }

export const fadeAnimate = { opacity: 1 }

export const fadeTransition = { duration: 0.3, ease: 'easeInOut' }

export const gridDragConfig = { cancel: `.${trackingPageBlockDeleteButtonClassName}` }

const resizeHandleAxes = { left: 'w', right: 'e', bottom: 's', bottomLeft: 'sw', bottomRight: 'se' }

export const gridResizeHandles = {
  horizontal: [resizeHandleAxes.left, resizeHandleAxes.right],
  all: [
    resizeHandleAxes.left,
    resizeHandleAxes.right,
    resizeHandleAxes.bottom,
    resizeHandleAxes.bottomLeft,
    resizeHandleAxes.bottomRight,
  ],
}

export const gridResizeConfigs = {
  [previewViewModes.desktop]: { enabled: true, handles: gridResizeHandles.horizontal },
  [previewViewModes.mobile]: { enabled: false },
}

export const literalTranslationOptions = { nsSeparator: false, keySeparator: false }
